module.exports = __webpack_public_path__ + "img/excel.6ff7f070.png";